define('controllers/myaccount/myaccount',['app', 'mainCons'], function (app, mainCons) {
    app.controller('MyAccount', ['$scope', '$rootScope', '$state', '$location', 'UserInfo', 'auiDialog', 'tenantsService',
        function ($scope, $rootScope, $state, $location, UserInfo, auiDialog, tenantsService) {

            var Model = $scope.Model = {
                menuIsActive : 1,
                //是否显示余额的耀星流量券账户，避免余额页面的重复刷新此变量的值
                showYXQTab: false,
                //默认是通过菜单进入，用page标识
                eventSource: 'page',
                showFooter:true
            };
            init();

            function init() {
                var path = $location.path();
                if (path.indexOf('/myaccount/earnings') >= 0) {
                    Model.menuIsActive = 2;
                }
                else if (path.indexOf('/myaccount/service') >= 0) {
                    Model.menuIsActive = 3;
                } else if (path.indexOf('/myaccount/accountLevel') >= 0) {
                    Model.menuIsActive = 3;
                } else if (path.indexOf('/myaccount/productLevel') >= 0) {
                    Model.menuIsActive = 3;
                }
                if((path.indexOf('/myaccount/bills') >= 0 || path.indexOf('/myaccount/new-earnings') >= 0)){
                    Model.showFooter = false;
                }
            }


        }]);
});
